export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_06.a914833d.jpg";